import React from 'react';
var getGlobalObject = function getGlobalObject() {
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  // 全局对象不存在，抛出错误或者进行特殊处理
  throw new Error('no global object');
};
export var theGlobal = getGlobalObject();

/** sdk内部使用 */
export var pandaSelf = {
  debug: false
};

/** 判断当前是否支持React 并且 React版本不小于1.6.8 */
export var isSupportReact = !!(React && React.createContext);